import React, { FC } from "react";
import styled from "styled-components";

interface Props {
  white?: boolean;
}

const Spinner: FC<Props> = ({ white, ...props }) => (
  <StyledSpinner viewBox="0 0 50 50" white={white} {...props}>
    <circle
      className="path"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      strokeWidth="4"
    />
  </StyledSpinner>
);

const StyledSpinner = styled.svg<Props>`
  animation: rotate 2s linear infinite;
  width: 100%;
  height: 50px;

  & .path {
    stroke: ${({ white }) => (white ? "#ece3e3" : " #c5bebe")};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export default Spinner;
